// src/pages/gate/GateLogin.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./GateLogin.css";

export default function GateLogin() {
  const [staffName, setStaffName] = useState("");
  const [shiftPin, setShiftPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      if (!staffName.trim()) {
        throw new Error("Staff name is required");
      }

      if (!shiftPin.trim()) {
        throw new Error("Shift PIN is required");
      }

      const API = process.env.REACT_APP_API_URL;
      const response = await fetch(`${API}/api/gate/shift-login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          staffName: staffName.trim(),
          shiftPin: shiftPin.trim()
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Login failed");
      }

      const data = await response.json();

      // Store gate staff info and shift details
      localStorage.setItem("gateToken", data.token);
      localStorage.setItem("gateName", staffName);
      localStorage.setItem("gateShiftId", data.shiftId);
      localStorage.setItem("gateShiftPin", shiftPin);

      // Navigate to pre-approvals dashboard
      navigate("/gate/pre-approvals");
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="gate-login-container">
      <div className="gate-login-card">
        <div className="gate-login-header">
          <h1>🏢 Gate Management</h1>
          <p>Crown Residences Visitor Entry</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleLogin} className="gate-login-form">
          <div className="form-group">
            <label htmlFor="staffName">Staff Name</label>
            <input
              type="text"
              id="staffName"
              value={staffName}
              onChange={(e) => setStaffName(e.target.value)}
              placeholder="Enter your name"
              className="gate-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="shiftPin">Shift PIN Code</label>
            <input
              type="password"
              id="shiftPin"
              value={shiftPin}
              onChange={(e) => setShiftPin(e.target.value)}
              placeholder="Enter today's shift PIN"
              className="gate-input"
              maxLength="6"
              required
            />
          </div>

          <button
            type="submit"
            className="gate-login-btn"
            disabled={loading}
          >
            {loading ? "Logging in..." : "🔐 Start Shift"}
          </button>
        </form>

        <div className="gate-login-info">
          <p>🔒 Main Gate Access - All Towers</p>
          <p>Shift PIN provided by Tower Admin</p>
        </div>
      </div>
    </div>
  );
}